import React, { useState, useEffect } from "react";
import {
  Table,
  Icon,
  Input,
  Dropdown,
  Message,
  Button,
} from "semantic-ui-react";
import { map } from "lodash";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Tooltip } from "react-tooltip";

export function TableCursos(props) {
  const { cursos, updateCurso, verCurso, deleteCurso } = props;
  const itemsPerPage = 9;
  const { auth } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [materiaSearch, setMateriaSearch] = useState("");
  const [grupoSearch, setGrupoSearch] = useState("");
  const [periodos, setPeriodos] = useState(null);
  const [periodoFormato, setPeriodoFormato] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState("");
  const [selectedPeriodoId, setSelectedPeriodoId] = useState(null);

  const handleMateriaSearchChange = (value) => {
    setMateriaSearch(value.toLowerCase());
    setCurrentPage(1);
  };

  const handleGrupoSearchChange = (value) => {
    setGrupoSearch(value.toLowerCase());
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredCursos =
    cursos?.filter(
      (curso) =>
        curso.materia_data.nombre_materia
          .toLowerCase()
          .includes(materiaSearch) &&
        curso.grupo_data.numero_grupo
          .toString()
          .toLowerCase()
          .includes(grupoSearch)
    ) || [];

  useEffect(() => {
    if (materiaSearch === "" && grupoSearch === "") {
      setCurrentPage(1);
    }
  }, [materiaSearch, grupoSearch]);

  useEffect(() => {
    const lastPage = Math.ceil(filteredCursos.length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [filteredCursos, currentPage]);

  const sortedCursos = filteredCursos.sort((cursoA, cursoB) => {
    const grupoA = cursoA.grupo_data.numero_grupo;
    const grupoB = cursoB.grupo_data.numero_grupo;
    return grupoA - grupoB;
  });

  const paginatedCursos = sortedCursos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  };

  let content = null;
  if (filteredCursos.length === 0) {
    content = (
      <Message
        info
        header="No hay cursos disponibles cargados para este período"
        content="Seleccione otro periodo para consultar los cursos."
      />
    );
  } else {
    content = (
      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>PERÍODO</Table.HeaderCell>
            <Table.HeaderCell>CLAVE</Table.HeaderCell>
            <Table.HeaderCell>MATERIA</Table.HeaderCell>
            <Table.HeaderCell>GRUPO</Table.HeaderCell>
            <Table.HeaderCell>DOCENTE</Table.HeaderCell>
            <Table.HeaderCell>ACCIONES</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {map(paginatedCursos, (curso, index) => (
            <Table.Row key={index}>
              <Table.Cell>{`${formatPeriodo(
                curso.periodo_data.fecha_inicio
              )} - ${formatPeriodo(curso.periodo_data.fecha_fin)}`}</Table.Cell>
              <Table.Cell>{curso.materia_data.clave_materia}</Table.Cell>
              <Table.Cell>{curso.materia_data.nombre_materia}</Table.Cell>
              <Table.Cell>{curso.grupo_data.numero_grupo}</Table.Cell>
              <Table.Cell>
                {curso.materia_data.es_de_titulacion
                  ? "ES MATERIA DE TITULACION"
                  : curso.user_data &&
                    curso.user_data.first_name &&
                    curso.user_data.last_name
                  ? `${curso.user_data.first_name} ${curso.user_data.last_name}`.toUpperCase()
                  : "PENDIENTE POR ASIGNAR"}
              </Table.Cell>
              <Actions
                curso={curso}
                updateCurso={updateCurso}
                deleteCurso={deleteCurso}
                verCurso={verCurso}
              />
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }

  return (
    <div>
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por materia"
          value={materiaSearch}
          onChange={(e) => handleMateriaSearchChange(e.target.value)}
          style={{ marginTop: "20px" }}
        />
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por grupo"
          value={grupoSearch}
          onChange={(e) => handleGrupoSearchChange(e.target.value)}
          style={{ marginTop: "20px" }}
        />
      </div>
      <div>{content}</div>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(filteredCursos.length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(filteredCursos.length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(filteredCursos.length / itemsPerPage);

            if (Math.ceil(filteredCursos.length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            }

            if (pageNumber === startPage && showStartEllipsis) {
              return (
                <Button key="startEllipsis" icon disabled>
                  ...
                </Button>
              );
            }

            if (pageNumber === endPage && showEndEllipsis) {
              return (
                <Button key="endEllipsis" icon disabled>
                  ...
                </Button>
              );
            }

            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}

function Actions(props) {
  const { curso, updateCurso, verCurso, deleteCurso } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        {/**
         * <Button
          icon
          className="yellow"
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Actualizar datos del curso"
          onClick={() => {
            updateCurso(curso);
          }}
        >
          <Icon name="pencil" style={{ color: "white" }}></Icon>
        </Button>
         */}

        <Button
          icon
          negative
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Eliminar curso"
          onClick={() => {
            deleteCurso(curso);
          }}
        >
          <Icon name="trash" style={{ color: "white" }}></Icon>
        </Button>
        <Button
          icon
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Ver alumnos del curso"
          onClick={() => {
            verCurso(curso);
          }}
          className="botonEnviar"
        >
          <Icon name="eye" style={{ color: "white" }}></Icon>
        </Button>
        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
